import Senses from './Senses';

export default Senses;
export { Senses };
